import { useDispatch, useSelector } from 'react-redux';

import { RcFile } from 'antd/es/upload';

import { RootState } from 'app/appStore';
import { addAttachments, ECreateOfferStages, setContractor, setCreateStage, setOfferType, TOfferForm } from 'entities/Offer';

import { clearAll, setAIMarkdown, setFormValues } from '../model/offerSlice';

export const useOfferSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.offerReducer),
		addAttachments: (material: RcFile) => dispatch(addAttachments(material)),
		clearAll: () => dispatch(clearAll()),
		setAIMarkdown: (text: string) => dispatch(setAIMarkdown(text)),
		setContractor: (contractor: string) => dispatch(setContractor(contractor)),
		setCreateStage: (stage: ECreateOfferStages) => dispatch(setCreateStage(stage)),
		setFormValues: (values: TOfferForm) => dispatch(setFormValues(values)),
		setOfferType: (type: string) => dispatch(setOfferType(type)),
	};
};
